import { useMemo } from "react";

import type { Position } from "~/v2/api/rest/account";
import { CRYPTO_LOCALE_OPTIONS } from "../utils";

interface GetCryptoAvailableQuantityParams {
  basePosition: Position | undefined;
  quotePosition: Position | undefined;
}

export const getCryptoAvailableQuantity = ({
  basePosition,
  quotePosition,
}: GetCryptoAvailableQuantityParams): {
  availableBase: string | undefined;
  availableQuote: string | undefined;
} => {
  const baseQtyAvailable = parseFloat(basePosition?.qty_available ?? "0");
  const quoteQtyAvailable = parseFloat(quotePosition?.qty_available ?? "0");

  return {
    availableBase:
      baseQtyAvailable > 0
        ? baseQtyAvailable.toLocaleString("en-US", CRYPTO_LOCALE_OPTIONS)
        : undefined,
    availableQuote:
      quoteQtyAvailable > 0
        ? quoteQtyAvailable.toLocaleString("en-US", CRYPTO_LOCALE_OPTIONS)
        : undefined,
  };
};

export const useCryptoAvailableQuantity = ({
  basePosition,
  quotePosition,
}: GetCryptoAvailableQuantityParams) => {
  return useMemo(
    () => getCryptoAvailableQuantity({ basePosition, quotePosition }),
    [basePosition, quotePosition],
  );
};
